import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Toaster } from 'react-hot-toast';

import { SessionProvider, useSession } from './context/SessionContext';
import { ProtectedRoute } from './components/layout';
import { 
  WelcomeScreen,
  EvaluationEntry,
  UploadResume, 
  DoNotCheat, 
  Questionnaire, 
  Challenge, 
  ChallengeInterview,
  Finished,
  VideoIntro,
  VideoIntroRMR
} from './components/pages';
import ConsoleTest from './components/utils/ConsoleTest';

// Component to conditionally render Challenge or ChallengeInterview based on session data
function ChallengeSelector() {
  const { sessionData } = useSession();
  
  // If it's interview type challenge, render the interview component
  if (sessionData?.challenge_type === 'interview') {
    return <ChallengeInterview />;
  }
  
  // Otherwise, render the regular quiz challenge
  return <Challenge />;
}

function App() {
  return (
    <SessionProvider>
      <Router>
        <div className="min-h-screen p-4">
          <Routes>
            {/* Welcome screen now uses ProtectedRoute for consistent navigation flow */}
            <Route path="/" element={
              <ProtectedRoute allowWithoutSession={true}>
                <WelcomeScreen />
              </ProtectedRoute>
            } />
            
            {/* Evaluation entry for unregistered candidates - public entry point, no session needed */}
            <Route path="/evaluation/:evaluation_id" element={<EvaluationEntry />} />
            
            <Route path="/:eid" element={
              <ProtectedRoute allowWithoutSession={true}>
                <WelcomeScreen />
              </ProtectedRoute>
            } />
            
            {/* Routes with path parameters */}
            <Route path="/resume/:eid" element={
              <ProtectedRoute>
                <UploadResume />
              </ProtectedRoute>
            } />
            
            <Route path="/videointro/:eid" element={
              <ProtectedRoute>
                <VideoIntro />
              </ProtectedRoute>
            } />
            
            <Route path="/notice/:eid" element={
              <ProtectedRoute>
                <DoNotCheat />
              </ProtectedRoute>
            } />
            <Route path="/questionnaire/:eid" element={
              <ProtectedRoute>
                <Questionnaire />
              </ProtectedRoute>
            } />
            <Route path="/challenge/:eid" element={
              <ProtectedRoute>
                <ChallengeSelector />
              </ProtectedRoute>
            } />
            <Route path="/finished/:eid" element={
              <ProtectedRoute>
                <Finished />
              </ProtectedRoute>
            } />
            
            {/* Test route for console log removal */}
            <Route path="/console-test" element={<ConsoleTest />} />
            
            {/* Test route for React Media Recorder */}
            <Route path="/video-test" element={<VideoIntroRMR />} />
          </Routes>
          <Toaster />
        </div>
      </Router>
    </SessionProvider>
  );
}

export default App;
